export const CHANGE_COURSEPROJECT_DATA = 'courseproject/CHANGE_COURSEPROJECT_DATA';
export const CHANGE_COURSEPROJECT_LIST_DATA = 'courseproject/CHANGE_COURSEPROJECT_LIST_DATA';
export const CHANGE_EXCELLENT_LIST = 'courseproject/CHANGE_EXCELLENT_LIST';
export const CHANGE_ATTACHMENT_LIST = 'courseproject/CHANGE_ATTACHMENT_LIST';
export const CHANGE_COLLECT = 'courseproject/CHANGE_COLLECT';
export const CHANGE_FINISHED = 'courseproject/FINISHED_LIST';
export const CHANGE_FINISHED_LOCK = 'courseproject/FINISHED_LIST_LOCK';
export const CHANGE_LASTCOURSE = 'courseproject/CHANGE_LASTCOURSE';











